import { useMemo } from "react";
import {
  Box,
  Container,
  Theme,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import moment from "moment";

import { colors } from "theme";

import { LegalLinks } from "./components/LegalLinks";

export interface ILinksPanel {
  title: string;
  links: Array<{ text: string; href?: string }>;
}

export const Footer = () => {
  const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down(640));
  const currentYear = useMemo(() => moment().year(), []);

  return (
    <Box
      component="footer"
      role="contentinfo"
      bgcolor="primary.dark"
      pt={isMobile ? 3 : 5.5}
      pb={isMobile ? 3 : 5.5}
      color={colors.white}
    >
      <Container>
        <Box
          mb={2.5}
          className="disclaimer-content"
          color="common.white"
          display="flex"
          flexDirection="column"
          rowGap="10px"
        >
          <FooterText>
            © {currentYear} Integrated DNA Technologies, Inc.
          </FooterText>
        </Box>
        <LegalLinks />
      </Container>
    </Box>
  );
};

const FooterText = styled((props) => <Typography {...props} />)({
  fontSize: 14,
  lineHeight: "18px",
  letterSpacing: 0,
});
